import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: null,
  name: null,
  userCount: null,
  dateCreated: null,
  isDisabled: null,
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanyDetails: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearCompanyDetails: () => {
      return initialState;
    },
  },
});

export const { setCompanyDetails, clearCompanyDetails } = companySlice.actions;

// Selectors
export const getCompanyDetails = state => state.company;

// Helper function to get company ID
export const getCompanyId = state => state.company?.id || null;

export default companySlice.reducer;
